module.exports = __webpack_public_path__ + "img/eshop-2.03b02740.png";